import API from '../../api';

// Servizio condiviso per il recupero delle entità master GD (GET /entities/gd_registration).
// De-duplica la costruzione della query e la forma della risposta finora ripetute in
// RegistrationPage, ProfilePage, cardsTab e UserContext.
// La RISOLUZIONE di città/provincia (residenza vs domicilio, login, ecc.) resta nei componenti,
// perché varia da caso a caso: qui si centralizza solo la chiamata identica.

/**
 * Recupera le entità master GD, opzionalmente filtrate per comune/provincia.
 *  - senza parametri → tutte le entità GD (contesti admin/anagrafica);
 *  - con city_id/province_id → filtro geografico (BE: prima città, poi fallback provincia).
 *
 * @param {object} [params]
 * @param {string} [params.cityId]
 * @param {string} [params.provinceId]
 * @returns {Promise<{entities: Array<object>, empty: boolean}>}
 */
export async function fetchGdEntities({ cityId, provinceId } = {}) {
  const query = [cityId ? `city_id=${cityId}` : '', provinceId ? `province_id=${provinceId}` : '']
    .filter(Boolean)
    .join('&');
  const url = query ? `/entities/gd_registration?${query}` : '/entities/gd_registration';

  const res = await API.get(url);
  return {
    entities: res.data?.entities || [],
    empty: !!res.data?.empty,
  };
}
